import {
  localizedInstructionValue,
  localizedIngredientName,
  localizedPreparation,
} from "./localize";
import type { Ingredient, IngredientOption, Locale, RecipeSlot } from "./types";

const TOKEN = /\{([a-z0-9-]+)\.([a-zA-Z][a-zA-Z0-9-]*)\}/g;

export function hasValidTemplateSyntax(template: string): boolean {
  return !/[{}]/.test(template.replace(TOKEN, ""));
}

export function templateTokens(
  template: string,
): Array<{ slotId: string; field: string }> {
  return [...template.matchAll(TOKEN)].map((match) => ({
    slotId: match[1],
    field: match[2],
  }));
}

export function renderTemplate(
  template: string,
  values: Map<
    string,
    { slot: RecipeSlot; ingredient: Ingredient; option: IngredientOption }
  >,
  locale: Locale = "en",
): string {
  if (!hasValidTemplateSyntax(template)) {
    throw new Error("Malformed recipe template token");
  }
  return template.replace(TOKEN, (_token, slotId: string, field: string) => {
    const value = values.get(slotId);
    if (!value) throw new Error(`Unknown recipe slot token: ${slotId}`);
    if (field === "name")
      return localizedIngredientName(value.ingredient, locale);
    if (field === "preparation")
      return localizedPreparation(value.option, locale) ?? "";
    const instructionValue = localizedInstructionValue(
      value.option,
      field,
      locale,
    );
    if (instructionValue === undefined)
      throw new Error(`Missing instruction value: ${slotId}.${field}`);
    return instructionValue;
  });
}
